'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _commonchangedtodrg = require('./commonchangedtodrg.component');

var _commonchangedtodrg2 = _interopRequireDefault(_commonchangedtodrg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var commonchangedtodrgModule = _angular2.default.module('commonchangedtodrg', [_angularUiRouter2.default]).component('commonchangedtodrg', _commonchangedtodrg2.default);

exports.default = commonchangedtodrgModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/commonchangedtodrg/commonchangedtodrg.js